import { ref } from 'vue'

const suppressed = ref(false)
let timer: ReturnType<typeof setTimeout> | null = null

export function suppressTooltips(ms = 500) {
  if (timer) clearTimeout(timer)
  suppressed.value = true
  timer = setTimeout(() => {
    suppressed.value = false
    timer = null
  }, ms)
}

export function useTooltipSuppressor() {
  return { suppressed }
}
